import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Lenis from "lenis";
import Landing from "@/pages/Landing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Billing from "@/pages/Billing";
import Login from "@/pages/Login";
import Account from "@/pages/Account";
import ResetPassword from "@/pages/ResetPassword";
import AdminWingman from "@/pages/AdminWingman";
import Workspace from "@/pages/Workspace";
import Admin from "@/pages/Admin";
import AdminBrand from "@/pages/AdminBrand";
import AdminLegal from "@/pages/AdminLegal";
import Engines from "@/pages/Engines";
import SignContract from "@/pages/SignContract";
import ClientPortal from "@/pages/ClientPortal";
import Changelog from "@/pages/Changelog";
import ToolPage from "@/pages/ToolPage";
import { TOOLS } from "@/data/tools";
import { AuthProvider } from "@/context/AuthContext";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onAnchor = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (a) {
        const el = document.querySelector(a.getAttribute("href"));
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -80 });
        }
      }
    };
    document.addEventListener("click", onAnchor);
    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", onAnchor);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-page min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/billing" element={<Billing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/account" element={<Account />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/admin/wingman" element={<AdminWingman />} />
            <Route path="/marketing-studio" element={<Navigate to="/admin/wingman" replace />} />
            <Route path="/workspace" element={<Workspace />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/brand" element={<AdminBrand />} />
            <Route path="/admin/legal" element={<AdminLegal />} />
            <Route path="/engines" element={<Engines />} />
            <Route path="/sign/:token" element={<SignContract />} />
            <Route path="/portal/:token" element={<ClientPortal />} />
            <Route path="/changelog" element={<Changelog />} />
            {TOOLS.map((t) => (
              <Route key={t.slug} path={`/${t.slug}`} element={<ToolPage slug={t.slug} />} />
            ))}
            <Route path="*" element={<Landing />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
